(() => {
  const root = window.Shopify?.routes?.root || '/';
  const closeMegaMenus = (except) => document.querySelectorAll('[data-ky-mega][open]').forEach(menu => { if (menu !== except) menu.open = false; });
  const initHeader = () => {
    const header = document.querySelector('[data-ky-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    header.querySelectorAll('[data-ky-mega]').forEach(menu => menu.addEventListener('toggle', () => { if (menu.open) closeMegaMenus(menu); }));
    const dialog = document.querySelector('[data-ky-menu]');
    const opener = header.querySelector('[data-ky-menu-open]');
    let menuMotion, menuClosing = false, previousBodyOverflow = '';
    const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const closeMobileMenu = () => {
      if (!dialog?.open || menuClosing) return;
      menuClosing = true;
      menuMotion?.cancel();
      if (reducedMotion()) { dialog.close(); return; }
      dialog.classList.add('is-closing');
      menuMotion = dialog.animate([{transform:'translateY(0)',opacity:1},{transform:'translateY(calc(100% + 70px))',opacity:.65}],{duration:260,easing:'cubic-bezier(.4,0,1,1)'});
      menuMotion.addEventListener('finish', () => dialog.close(), {once:true});
    };
    opener?.addEventListener('click', () => {
      if (!dialog || dialog.open) return;
      hideResults(); closeMegaMenus();
      previousBodyOverflow = document.body.style.overflow;
      dialog.classList.remove('is-closing'); menuClosing = false;
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ky-menu-open');
      document.body.style.overflow = 'hidden';
      if (!reducedMotion()) menuMotion = dialog.animate([{transform:'translateY(calc(100% + 70px))',opacity:.7},{transform:'translateY(0)',opacity:1}],{duration:430,easing:'cubic-bezier(.22,1,.36,1)'});
    });
    dialog?.querySelector('[data-ky-menu-close]')?.addEventListener('click', closeMobileMenu);
    dialog?.addEventListener('cancel', event => {event.preventDefault();closeMobileMenu();});
    dialog?.addEventListener('click', event => {if (event.target === dialog) closeMobileMenu();});
    dialog?.addEventListener('close', () => {
      menuMotion?.cancel(); menuClosing = false;
      dialog.classList.remove('is-closing');
      opener?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ky-menu-open');
      document.body.style.overflow = previousBodyOverflow;
      if (opener?.getClientRects().length) opener.focus();
    });
    const desktopMenuMedia = matchMedia('(min-width: 990px)');
    const onDesktopMenu = event => {if (event.matches && dialog?.open) dialog.close();};
    desktopMenuMedia.addEventListener('change', onDesktopMenu);
    const unloadMenu = event => {
      if (!event.target.contains(header)) return;
      if (dialog?.open) dialog.close();
      headerSizeObserver.disconnect();
      document.documentElement.style.removeProperty('--ky-sticky-header-height');
      desktopMenuMedia.removeEventListener('change', onDesktopMenu);
      document.removeEventListener('shopify:section:unload', unloadMenu);
    };
    document.addEventListener('shopify:section:unload', unloadMenu);
    const search = header.querySelector('[data-ky-search]');
    const input = search?.querySelector('[data-ky-search-input]');
    const results = search?.querySelector('[data-ky-search-results]');
    const defaults = search?.querySelector('[data-ky-search-default]');
    const live = search?.querySelector('[data-ky-search-live]');
    const status = search?.querySelector('[data-ky-search-status]');
    const scrim = search?.querySelector('.ky-search__scrim');
    let timeout, controller, requestId=0;
    const positionResults=()=>{if(!results || results.hidden)return;const rect=input.getBoundingClientRect();const margin=innerWidth<750?16:40;const width=Math.min(900,innerWidth-margin*2);results.style.width=width+'px';results.style.left=Math.max(margin,Math.min(rect.left,innerWidth-width-margin))+'px';results.style.top=(rect.bottom+14)+'px';results.style.maxHeight=Math.max(180,innerHeight-rect.bottom-30)+'px';};
    const headerSection = header.closest('.shopify-section');
    const announcement = headerSection?.querySelector('.ky-announcement');
    const headerUsps = headerSection?.querySelector('.ky-usps');
    const measureHeader = () => {
      if (!headerSection?.isConnected) return;
      const announcementHeight = announcement?.offsetHeight || 0;
      headerSection.style.setProperty('--ky-announcement-height', announcementHeight + 'px');
      document.documentElement.style.setProperty('--ky-sticky-header-height', (header.offsetHeight + (headerUsps?.offsetHeight || 0)) + 'px');
      positionResults();
    };
    const headerSizeObserver = new ResizeObserver(measureHeader);
    [header, announcement, headerUsps].filter(Boolean).forEach(element => headerSizeObserver.observe(element));
    measureHeader();
    const hideResults=()=>{requestId++;clearTimeout(timeout);controller?.abort();if(results)results.hidden=true;if(scrim)scrim.hidden=true;search?.classList.remove('is-open');input?.setAttribute('aria-expanded','false');};
    const showResults=()=>{if(!results)return;results.hidden=false;scrim.hidden=false;search.classList.add('is-open');input.setAttribute('aria-expanded','true');closeMegaMenus();positionResults();};
    const loadSearch=()=>{
      clearTimeout(timeout);controller?.abort();const current=++requestId;const query=input.value.trim();
      showResults();defaults.hidden=query.length>=2;live.hidden=query.length<2;status.hidden=true;
      if(query.length<2){live.replaceChildren();return;}
      live.replaceChildren();status.hidden=false;
      timeout=setTimeout(async()=>{controller=new AbortController();try{
        const url=new URL(root+'search/suggest',location.origin);url.search=new URLSearchParams({q:query,section_id:'ky-predictive-search','resources[type]':'product,query,collection','resources[limit]':'5','resources[options][unavailable_products]':'last'});
        const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('Search unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');const content=doc.querySelector('[data-ky-predictive-content]');
        if(current!==requestId || query!==input.value.trim() || !content)return;live.replaceChildren(content);status.hidden=true;positionResults();
      }catch(error){if(error.name!=='AbortError' && current===requestId){status.hidden=true;defaults.hidden=false;live.hidden=true;}}},180);
    };
    input?.addEventListener('input',loadSearch);
    input?.addEventListener('focus',loadSearch);
    search?.querySelectorAll('[data-ky-search-close]').forEach(button=>button.addEventListener('click',hideResults));
    search?.querySelectorAll('[data-ky-search-term]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();input.value=link.dataset.kySearchTerm;input.focus();loadSearch();}));
    search?.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();input.focus();hideResults();}if(event.key==='ArrowDown' && event.target===input && !results.hidden){event.preventDefault();results.querySelector('[data-ky-search-live]:not([hidden]) a, [data-ky-search-default]:not([hidden]) a')?.focus();}});
    search?.addEventListener('focusout',()=>setTimeout(()=>{if(!search.contains(document.activeElement))hideResults();},0));
    addEventListener('resize',positionResults);addEventListener('scroll',positionResults,{passive:true});
    document.addEventListener('click',event=>{if(!header.contains(event.target))closeMegaMenus();if(!search?.contains(event.target))hideResults();});
    document.addEventListener('keydown', event => { if (event.key === 'Escape') { const summary = header.querySelector('[data-ky-mega][open] summary'); closeMegaMenus(); summary?.focus(); } });
  };
  const initTabs = () => document.querySelectorAll('[data-ky-products]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const tabs = [...section.querySelectorAll('[data-ky-tab]')];
    const activate = (tab, focus = false) => tabs.forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
      if (active && focus) item.focus();
    });
    const browse = section.querySelector('[data-ky-browse]');
    if (browse) {
      const previous = browse.querySelector('[data-ky-browse-prev]');
      const next = browse.querySelector('[data-ky-browse-next]');
      const activeGrid = () => section.querySelector('.ky-products-panel:not([hidden]) .ky-products-grid');
      const syncBrowse = () => {
        const grid = activeGrid();
        if (!grid || !section.isConnected) return;
        browse.hidden = grid.scrollWidth <= grid.clientWidth + 2;
        previous.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
        previous.setAttribute('aria-controls', grid.parentElement.id);
        next.setAttribute('aria-controls', grid.parentElement.id);
      };
      const move = direction => {
        const grid = activeGrid();
        if (!grid) return;
        grid.scrollBy({left: direction * grid.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      const observer = new ResizeObserver(syncBrowse);
      section.querySelectorAll('.ky-products-grid').forEach(grid => {
        grid.addEventListener('scroll', syncBrowse, {passive: true});
        observer.observe(grid);
      });
      section.addEventListener('click', () => requestAnimationFrame(syncBrowse));
      section.addEventListener('keydown', () => requestAnimationFrame(syncBrowse));
      const disconnectShelf = event => {
        if (!event.target.contains(section)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', disconnectShelf);
      };
      document.addEventListener('shopify:section:unload', disconnectShelf);
      syncBrowse();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        activate(tabs[next], true);
      });
    });
  });
  const initCart = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.kyReady) return;
    drawer.dataset.kyReady = 'true';
    let loading = false;
    const load = async () => {
      if (!drawer.classList.contains('active') || drawer.classList.contains('is-empty') || loading) return;
      const slot = drawer.querySelector('[data-ky-cart-recommendations]');
      if (!slot || slot.dataset.loaded) return;
      loading = true;
      try {
        const response = await fetch(root + 'cart?section_id=ky-cart-recommendations');
        if (!response.ok) throw new Error('Cart suggestions unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('.ky-cart-recommendations');
        if (content?.querySelector('a') && slot.isConnected) slot.replaceChildren(content);
        if (slot.isConnected) slot.dataset.loaded = 'true';
      } catch {} finally { loading = false; }
    };
    new MutationObserver(load).observe(drawer, {attributes:true,attributeFilter:['class'],childList:true,subtree:true});
  };
  const initCountdown = () => document.querySelectorAll('[data-ky-countdown]').forEach(timer => {
    if (timer.dataset.ready) return;
    timer.dataset.ready = 'true';
    const end = Date.parse(timer.dataset.kyCountdown);
    if (!Number.isFinite(end)) return;
    const update = () => {
      const seconds = Math.floor((end - Date.now()) / 1000);
      timer.hidden = seconds <= 0;
      if (seconds <= 0) return false;
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor(seconds % 86400 / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      timer.textContent = `${days}d : ${String(hours).padStart(2,'0')}u : ${String(minutes).padStart(2,'0')}m : ${String(seconds % 60).padStart(2,'0')}s`;
      return true;
    };
    if (update()) { const interval = setInterval(() => { if (!timer.isConnected || !update()) clearInterval(interval); }, 1000); }
  });
  const init = () => { initHeader(); initTabs(); initCart(); initCountdown(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
